module.exports = __webpack_public_path__ + "img/section7.41b019f4.png";